var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 8.33301C24.6667 12.1988 21.5324 15.333 17.6667 15.333C16.4843 15.333 15.3707 15.0396 14.3942 14.5222L4.25001 24.6663L1.33334 21.7497L11.4775 11.6055C10.9435 10.5975 10.6651 9.47375 10.6667 8.33301C10.6667 4.46726 13.8009 1.33301 17.6667 1.33301C18.8491 1.33301 19.9627 1.62584 20.9392 2.14384L16.5 6.58301L19.4167 9.49968L23.8558 5.06051C24.3898 6.06856 24.6682 7.19226 24.6667 8.33301Z",
    stroke: "#1076BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.7358b02a5c98f44e20ab73f6937610cc.svg";
export { ForwardRef as ReactComponent };